import { PaperScope, Size, CompoundPath, Point, Path } from 'paper'
import UI from './utils/UI'
import bus from 'bus'
import { mq, colors } from 'config'
import defs from '../../includes/shape/shape.json'

const fills = [
  colors.blue,
  colors.red,
  colors.green
]

UI({
  component: '.js-productTimeline',
  items: ['.js-productTimeline-item'],
  canvas: '.js-productTimeline-canvas'
}, ({ component, items, canvas }) => {
  const scope = new PaperScope()
  scope.setup(canvas)
  scope.view.setViewSize(new Size(canvas.clientWidth, canvas.clientHeight))
  scope.view.draw()
  draw(canvas, items, scope.project.activeLayer)

  bus.on('window-resize', _ => {
    scope.project.activeLayer.removeChildren()
    scope.view.setViewSize(new Size(canvas.clientWidth, canvas.clientHeight))
    draw(canvas, items, scope.project.activeLayer)
  })
})

function draw(canvas, items, activeLayer) {
  const controlPoints = getControlPoints(canvas, items)

  drawTimeline(canvas, controlPoints, activeLayer)
  drawBlobs(controlPoints, activeLayer)
}

function drawBlobs(controlPoints, activeLayer) {
  activeLayer.addChildren(controlPoints.map((point, index) => {
    const blobPath = new CompoundPath(defs.blob.path)
    blobPath.position = new Point(point.x + (Math.random() * 10 - 5), point.y)
    blobPath.rotate(Math.random() * 360)
    blobPath.scale(0.125)
    blobPath.fillColor = mq.md.matches ? fills[index] : null
    return blobPath
  }))
}

function getControlPoints (canvas, items) {
  const canvasBCR = canvas.getBoundingClientRect()
  return items.map((item, index) => {
    const itemBCR = item.getBoundingClientRect()
    let x = 0
    switch (index) {
      case 0 :
        x = mq.md.matches ? 70 : canvas.clientWidth * 0.6
        break
      case 1 :
        x = mq.md.matches ? canvas.clientWidth - 70 : canvas.clientWidth * 0.9
        break
      case 2:
        x = mq.md.matches ? 50 : canvas.clientWidth * 0.2
        break
    }
    const y = (itemBCR.top - canvasBCR.top) + item.clientHeight * 0.33
    return new Point(x, y)
  })
}

function drawTimeline (canvas, controlPoints, activeLayer) {
  const points = [
    new Point(canvas.clientWidth * (mq.md.matches ? 0.75 : 0.9), 6),
    ...controlPoints,
    new Point(canvas.clientWidth * (mq.md.matches ? 0.75 : 0.5), canvas.clientHeight - 6)
  ]
  activeLayer.addChild(new Path({
    strokeColor: '#e6e6e6',
    strokeWidth: 10,
    strokeCap: 'round',
    segments: points,
    dashArray: [0, 25],
    name: 'timeline-path'
  }))
  activeLayer.children['timeline-path'].smooth({ type: 'continuous' })
}
